<template>
  <div class="questionnaire-question-content">

    <div class="questionnaire-question-sentence">
      {{ question }}
    </div>

    <div class="questionnaire-question-question">
      {{ subQuestion }}
    </div>

    <div class="questionnaire-question-response-time">
      <Field id="responseHeure" autocomplete="off" autocorrect="off" class="questionnaire-question-response-time-input" name="responseHeure" x-webkit-speech="off" @change="changeOnField()"/>
      h
      <Field id="responseMinute" autocomplete="off" autocorrect="off" class="questionnaire-question-response-time-input" name="responseMinute" x-webkit-speech="off" @change="changeOnField()"/>
      <div>min</div>
    </div>

    <div class="questionnaire-question-response-time">
      <span id="error-regex" class="text-danger"></span>
    </div>

    <ErrorMessage class="error-feedback" name="responseHeure"/>
    <ErrorMessage class="error-feedback" name="responseMinute"/>
  </div>
</template>

<script>
import {ErrorMessage, Field} from "vee-validate";
import UserService from "@/services/user.service";
import {nextTick} from "vue";

export default {
  name: "WriteTimeResponse",
  components: {
    Field,
    ErrorMessage,
  },
  props: {
    question: String,
    subQuestion: String,
    response: String,
    regex: String,
    error: Boolean
  },
  data() {
    return {}
  },
  methods: {
    changeOnField: function () {
      document.getElementById('error-regex').innerHTML = '';
      const value = document.getElementById('responseHeure').value + 'h'
          + document.getElementById('responseMinute').value + 'mn';

      this.answer = value;
      this.$emit('update:error', false)

    },
  },
  mounted() {
    UserService.getUserTestQuestions(this.$parent.domainId).then(
        (response) => {
          var arrayResponses = response.data.responses
          var index = (this.$parent.indexQuestion - 1)
          this.answer = null
          if (arrayResponses[index] != undefined && arrayResponses[index]['answer'] != undefined) {
            this.answer = arrayResponses[index]['answer']
            document.getElementById('responseHeure').value = this.answer.split('h')[0]
            var tmp = this.answer.split('h')[1]
            document.getElementById('responseMinute').value = tmp.split('mn')[0]
          }

          nextTick(()=>{
            this.$parent.pageIsLoaded = true
          })
        }
    );
  },
};
</script>
